import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading mb-2">{indexData.title}</h2>
          <p className="text-sm text-foreground-500">{indexData.subtitle}</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexData.items.map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              className="block bg-background-100 border border-background-200 rounded-xl p-5 hover:border-primary-300 hover:bg-primary-50/50 transition-colors group cursor-pointer"
            >
              <div className="flex items-center justify-between mb-2">
                <h3 className="text-sm font-bold text-foreground-800 group-hover:text-primary-600 transition-colors">{item.name}</h3>
                <span className="text-xs text-foreground-400">{item.count}</span>
              </div>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}